/**
 * Resolve customer display name from V2 contact fields.
 * Keeps a customer.name backstop for edge cases but all callers
 * should rely on this single canonical utility.
 */
function getCustomerDisplayName(customer) {
  const first = customer?.contact?.firstName || '';
  const last = customer?.contact?.lastName || '';
  const full = `${first} ${last}`.trim();
  return full || customer?.name || 'Unknown';
}

module.exports = { getCustomerDisplayName };
